/**
 * 受注詳細 排出承認メール再申請
 */
import Vue from 'vue'
import * as httpConst from '../../../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/orders/accepts/collections`

const order_accept_collection_send_mail_approval = {
  namespaced: true,
  actions: {
    /**
     * 表示データの取得
     * @param commit
     * @param id
     * @return {Promise<unknown>}
     */
    edit ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}/send_mail_approvals/edit`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
    /**
     * 再申請 更新
     * @param commit
     * @param id
     * @return {Promise<unknown>}
     */
    update ({ commit }, { id }) {
      return new Promise( ( resolve ) => {
        const api_path = `${API_PATH}/${id}/send_mail_approvals`
        Vue.$http.put(api_path).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
          resolve(content)
        } )
      })
    },
  },
}
export default order_accept_collection_send_mail_approval
